import { useState } from "react";
import { useHistory } from "react-router-dom";
import { issuesTrackerApi } from "features/IssuesTracker/issuesTrackerSlice";
import LinkedTicketDialog from "features/mechanicalWork/components/WorkOrderLinkedTickets/LinkedTicketDialog";

export const useTicketDialog = (onOpenTicket) => {
    const history = useHistory();
    const [ticketId, setTicketId] = useState();
    const prefetchTicket = issuesTrackerApi.usePrefetch('getIssueTrackerById');

    const openTicket = (id) => {
        if (onOpenTicket) {
            onOpenTicket(id);
        } else {
            setTicketId(id);
        }
    };

    const prefetch = (id) => prefetchTicket({ id });

    const openWorkOrderFromTicket = (id) => {
        setTicketId(null);
        if (history.location.pathname !== `/workorder/${id}`) {
            history.push(`/workorder/${id}`);
        }
    };

    const ticketDialog = (
        <>
            {!!ticketId &&
                <LinkedTicketDialog
                    ticketId={ticketId}
                    onClose={() => setTicketId(null)}
                    onOpenWorkOrder={openWorkOrderFromTicket}
                />
            }
        </>
    );

    return { openTicket, prefetch, ticketDialog };
};
